export const RecaptchaMixin = {
    props: {
        recaptchaKey: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            recaptchaResponse: null
        };
    },

    methods: {
        prepRecaptcha: function(recaptcha) {
            if (this.recaptchaResponse) {
                this.recaptchaResponse = null;
                recaptcha.reset();
            }
        },

        onVerify: function(response) {
            this.recaptchaResponse = response;
        },

        onExpired: function() {
            this.recaptchaResponse = null;
        }
    }
};
